<i18n
  src="@/locales/views/packing_house/process/exec_steps/new_exec_attr.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/process_line_exec_step.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_input.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_output.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_attr.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="this.routeName('show_exec_step')"
    :params="{
      packing_house_id: this.packing_house_id,
      packing_house_process_id: this.packing_house_process_id,
      process_line_step_id: this.process_line_step_id,
      id: this.id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, packing_house_process.name, process_line_step.name]"
  ></bread-crumbs>

  <div class="my-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title_exec_step") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.process_line_exec_step.executed_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(process_line_exec_step.executed_at) }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.process_line_exec_step.process_line") }}
              </dt>
              <dd class="content-data">
                {{ process_line_exec_step.process_line?.name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <alert-danger :errors_data="std_err" />

  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div
            v-for="(process_line_step_attr, index) in process_line_step_attrs"
            :key="process_line_step_attr.id"
            class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4"
          >
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ process_line_step_attr.name }}
              </label>
              <div class="mt-1">
                <input
                  v-if="process_line_step_attr.value_type == 'value_float'"
                  type="text"
                  v-model.trim="process_line_exec_attrs[index].value_float"
                  :class="['input-text', isInvalid('value_float')]"
                />
                <input
                  v-if="process_line_step_attr.value_type == 'value_string'"
                  type="text"
                  v-model.trim="process_line_exec_attrs[index].value_string"
                  :class="['input-text', isInvalid('value_string')]"
                />
                <select-form
                v-if="process_line_step_attr.value_type == 'value_record'"
                  :options="process_line_step_attr.process_line_attr_options"
                  v-model="process_line_exec_attrs[index].value_record"
                  label="value"
                  :is_invalid="isInvalidSelect('process_line')"
                />
              </div>
            </div>
            <div
              v-if="process_line_step_attr.value_type == 'value_float'"
              class="sm:col-span-3"
            >
              <label class="label-form">
                {{ $t("model.process_line_exec_attr.unit") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="process_line_exec_attrs[index].unit"
                  :class="['input-text', isInvalid('unit')]"
                />
              </div>
            </div>
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.process_line_exec_attr.observations") }}
              </label>
              <div class="mt-1">
                <textarea
                  v-model="process_line_exec_attrs[index].observations"
                  rows="3"
                  :class="['input-text-area', isInvalid('observations')]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowExecStep"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!charging_submit"
            @click.prevent="save()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/new_exec_attr.js";

export default {
  name: "PHProcessExecStepsNewExecAttr",
  data() {
    return {
      load_general_data: false,
      packing_house_process: {},
      process_line_step: {},
      process_line_exec_step: {},
      process_line_step_attrs: [],
      process_line_exec_attrs: [],
      charging_submit: false,
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    process_line_step_id: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.loadData();
      })
    );
  },
  methods: {
    loadData: async function () {
      this.fetchPackingHouseProcess();
      this.fetchProcessLineStep();
      await this.fetchProcessLineExecStep();
      await this.fetchProcessLineStepAttrs();
      this.load_general_data = true;
    },

    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },

    fetchProcessLineStep: async function () {
      let response = await Requester.fetchProcessLineStep(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_step = response.data;
    },

    fetchProcessLineExecStep: async function () {
      let response = await Requester.fetchProcessLineExecStep(
        this.packing_house_id,
        this.id
      );
      this.process_line_exec_step = response.data;
    },

    fetchProcessLineStepAttrs: async function () {
      let response = await Requester.fetchProcessLineStepAttrs(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_step_attrs = response.data;
      this.process_line_exec_attrs = response.data.map((attr) => {
        const exec_attr =
          this.process_line_exec_step.process_line_exec_attrs.find(
            (exec_attr) => exec_attr.process_line_step_attr_id === attr.id
          );
        let exec_attr_data = {
          id: exec_attr?.id ?? null,
          process_line_step_attr_id: attr.id,
          value: exec_attr?.value,
          unit: exec_attr?.unit ?? attr.unit,
          observations: exec_attr?.observations,
        };

        if (attr.value_type === "value_float") {
          exec_attr_data["value_float"] = exec_attr?.value_float;
        } else if (attr.value_type === "value_string") {
          exec_attr_data["value_string"] = exec_attr?.value_string;
        } else if (attr.value_type === "value_record") {
          exec_attr_data["value_record"] = exec_attr?.value_record;
        }

        return exec_attr_data;
      });
    },

    save: async function () {
      this.charging_submit = true;
      try {
        const response = await Requester.save(
          this.packing_house_id,
          this.id,
          this.process_line_exec_attrs
        );
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowExecStep();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      } finally {
        this.charging_submit = false;
      }
    },

    goToShowExecStep: function () {
      this.$router.push({
        name: this.routeName("show_exec_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: this.process_line_step_id,
          id: this.id,
        },
      });
    },
  },
};
</script>
